const dittos = new Map();
let curr_products = new Map(),
  __productsOnPage;

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();

  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let tryOnScan = function (sku, callback) {
  $("#dittoTryon").show();
  $.get("/tools/live_auth_key/ditto-auth-credentials", function (e) {
    const t = document.getElementById("dittoTryon");
    t && (t.innerHTML += "");
    let options = {
      tryOnServer: "https://vto.partners-eu.api.ditto.com",
      domSelector: "#dittoTryon",
      accessKey: e["X-Ditto-Access-Key-Id"],
      partnerSignature: e["X-Ditto-Signature"],
      partnerId: "taylormorris",
      font: "montserrat",
      enableFaceInsights: true,
      custom: {
        text: "#fff",
        bg: "#232136",
        "hover-text": "#ffffff",
        "hover-bg": "#232136",
      },
    };
    let dittoScan = new Ditto.Scan(options, {
      success: function success(callbackObject) {
        // ga('send', 'event', 'Ditto', 'SuccessScan', '');
        setCookie("dittoCookieId", callbackObject.scanId, 365);
        setCookie("dittoSignatureId", callbackObject.overlaySignature, 365);
        dittoScan.destroy();
        ga("send", "event", "Ditto", "Success Scan", sku);
        if (typeof callback === "function") {
          callback();
        } else {
          callbackObject.sku = sku;
          tryOnView(callbackObject);
        }
      },
      failure: function failure(callbackObject) {
        // ga('send', 'event', 'Ditto', 'FailureScan', '');
      },
      progress: function progress(callbackObject) {},
      close: function (callbackObject) {
        if ($(".Select_Tryon_View").length > 0) {
          $(".Select_Tryon_View")
            .addClass("Button--ditto")
            .removeClass("Button--secondary");
          $(".Select_Frame_View")
            .removeClass("Button--ditto")
            .addClass("Button--secondary");
          $(".Product__TryOn").hide();
          $(".Product__Gallery").show();
        }

        if ($(".FeatureText__ImageWrapper .AspectRatio").length > 0) {
          $(".FeatureText__ImageWrapper .AspectRatio").show();
        }

        if ($("#dittoTryon").length > 0) {
          $("#dittoTryon").hide();
        }

        $.magnificPopup.close();
      },
    });
  })["catch"](function (error) {
    throw new Error(error);
  });
};

let tryOnView = function (callbackObject) {
  var scanId = callbackObject.scanId; //
  var signature = callbackObject.overlaySignature;
  $("#dittoTryon").show();
  fetch("/tools/live_auth_key/ditto-auth-credentials/?message=".concat(scanId))
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var options = {
        tryOnServer: "https://vto.partners-eu.api.ditto.com",
        partnerId: "taylormorris",
        domSelector: "#dittoTryon",
        scanId: scanId,
        glassesId: callbackObject.sku,
        accessKey: data["X-Ditto-Access-Key-Id"],
        overlaySignature: data['X-Ditto-Signature'],
        enableFaceInsights: true,
      };
      var tryOn = new Ditto.Overlay(options, {
        initialized: function initialized() {},
        success: function success(e) {
          ga("send", "event", "Ditto", "Try On View", callbackObject.sku);
          var height =
            $(".Product__Wrapper").height() <= 640
              ? $(".Product__Wrapper").height()
              : 640;
          $("#dittoTryon").css("height", height + "px");
        },
        failure: function failure() {},
        onclick: function onclick() {},
      });
    })
    ["catch"](function (error) {
      throw new Error(error);
    });
};

let tryOnDelete = function (scanId, callback) {
  if (scanId) {
    $.get("/tools/live_auth_key/ditto-auth-credentials", function (e) {
      $.ajax({
        type: "DELETE",
        url: "https://vto.partners-eu.api.ditto.com/api/1.4/dittos/" + scanId,
        headers: {
          "X-Ditto-Access-Key-Id": e["X-Ditto-Access-Key-Id"],
          "X-Ditto-Signature": e["X-Ditto-Signature"],
        },
        success: function () {
          callback();
        },
      });
    })["catch"](function (error) {
      throw new Error(error);
    });
  }

  var dittoCookie = getCookie("dittoCookieId");
  var dittoSignature = getCookie("dittoSignatureId");
  if (dittoCookie) {
    setCookie("dittoCookieId", null, -1);
  }

  if (dittoSignature) {
    setCookie("dittoSignatureId", null, -1);
  }

  window.location.href = "/pages/try-on";
};

let changeToFrameView = function () {
  $(".Select_Frame_View")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      var that = $(this);
      $(".Product__TryOn").hide();
      $(".Product__Gallery").show();
      that.addClass("Button--secondary").removeClass("Button--ditto");
      $(".Select_Tryon_View")
        .addClass("Button--ditto")
        .removeClass("Button--secondary");
    });
};

let changeToTryOnView = function () {
  $(".Select_Tryon_View")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      var that = $(this);
      $(".Product__Gallery").hide();
      $(".Product__TryOn").show();
      $("#dittoTryon").show();
      that.removeClass("Button--ditto").addClass("Button--secondary");
      $(".Select_Frame_View")
        .addClass("Button--ditto")
        .removeClass("Button--secondary");

      var dittoCookie = getCookie("dittoCookieId");
      var dittoSignature = getCookie("dittoSignatureId");

      if (dittoCookie && dittoSignature) {
        tryOnView({
          scanId: dittoCookie,
          overlaySignature: dittoSignature,
          sku: that.data("sku"),
        });
      } else {
        tryOnScan(that.data("sku"));
      }
    });
};

let getFirstDittoSku = function () {
  if (document.getElementsByClassName("Select_Tryon_View").length > 0) {
    let elements = document.getElementsByClassName("Select_Tryon_View");
    return elements[0].dataset.sku;
  } else {
    let elements = document.getElementsByClassName("ProductItem__TryOn");
    for (let i = 0; i < elements.length; i++) {
      let element = elements[i];
      if (element.dataset.sku) {
        return element.dataset.sku;
      }
    }
  }
};
let retakeScan = function () {
  $('button[class="re-ditto_retake"]')
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      $(".FeatureText__ImageWrapper .AspectRatio").hide();
      $('iframe[name="ditto-iframe"]').remove();
      $(".re-ditto-edit").trigger("click");
      tryOnScan(getFirstDittoSku());
    });
};

let deleteScan = function () {
  $('button[class="re-ditto_delete"]')
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      $('iframe[name="ditto-iframe"]').remove();
      if ($("#dittoTryon").length > 0) {
        $("#dittoTryon").hide();
      }
      if ($(".Select_Frame_View").length > 0) {
        $(".Select_Frame_View").trigger("click");
        $(".ditto").hide();
      }
      $(".re-ditto-edit").trigger("click");
      $(".FeatureText__ImageWrapper .AspectRatio").show();
      tryOnDelete(getCookie("dittoCookieId"));
      $(".re-ditto-edit").hide();
    });
};

let toggleEditButton = function () {
  $(".re-ditto-edit")
    .off()
    .on("click", function () {
      if ($(".re-ditto").css("visibility") === "hidden") {
        $(".re-ditto").css("visibility", "visible");
      } else {
        $(".re-ditto").css("visibility", "hidden");
      }
    });
};

$(function () {
  toggleEditButton();
  retakeScan();
  deleteScan();
  changeToTryOnView();
  changeToFrameView();
  if ($(".Product__TryOn").length > 0) {
    $(".Product__TryOn").hide();
  }
  var dittoCookie = getCookie("dittoCookieId");
  var dittoSignature = getCookie("dittoSignatureId");

  if (dittoCookie && dittoSignature) {
    $(".Select_Tryon_View").trigger("click");
    $(".re-ditto-edit").show();
  } else {
    $(".Select_Frame_View").trigger("click");
    $(".re-ditto-edit").hide();
    $("#dittoTryon").hide();
    //           $('.ditto').hide();
  }
});
/*
ditto_vto.saveToCustomer = function(userId, scanId) {
  if (scanId) {
    // Request Token
    $.post(
      "/tools/{SEE STEP 5 i.e. auth_key}/update/",
      {
        user_id: userId,
        ditto_id: scanId
      },
      function(response) {
        var token = response.token;
        console.log("response request token", token);
        // Save ditto Id to Customer Info
        $.post(
          "/tools/{SEE STEP 5 i.e. auth_key}/update/",
          {
            user_id: userId,
            ditto_id: scanId,
            token: token
          },
          function(response) {
            console.log("Updated customer object successfuly", response);
          },
          "json"
        );
      },
      "json"
    );
  }
};*/
